import React from 'react';
import { FOOTER_HEADLINE, FOOTER_DISCLAIMER } from '../content';

const footerLinks = [
  {
    label: 'privacy policy',
    href: 'https://onehealthplus.com/privacy-policy/',
  },
  {
    label: 'terms of use',
    href: 'https://onehealthplus.com/terms-of-use/',
  },
];

const ArrowUpRight: React.FC = () => (
  <svg
    className="size-8 shrink-0 text-[#BEB8AE] transition-transform group-hover:translate-x-1 group-hover:-translate-y-1 md:size-8"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M7 17 17 7M8 7h9v9" />
  </svg>
);

export const LandingFooter: React.FC = () => {
  return (
    <footer className="px-4 pb-8 md:px-8">
      <div className="mx-auto max-w-[1180px] rounded-3xl bg-[#EFE9DD] px-6 py-6 md:px-14 md:py-8">
        <div className="flex flex-col justify-between gap-8 md:flex-row md:items-start">
          <h2 className="font-['Inter'] text-3xl font-normal leading-tight text-[#23262C] md:text-5xl">
            {FOOTER_HEADLINE.map((line) => (
              <span key={line} className="block font-['Inter'] text-3xl sm:text-[56px] font-light leading-[1.02] text-[#23262C]">
                {line}
              </span>
            ))}
          </h2>

          <nav
            aria-label="Legal links"
            className="flex flex-col gap-6 md:items-end md:pt-2"
          >
            {footerLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                target="_blank"
                rel="noopener noreferrer"
                className="group inline-flex items-start gap-4 text-xl sm:text-3xl font-normal lowercase leading-none text-black transition-opacity hover:opacity-75 md:text-[28px]"
              >
                <span>{link.label}</span>
                <ArrowUpRight />
              </a>
            ))}
          </nav>
        </div>

        <div className="mt-12 max-w-4xl">
          <p className="text-[11px] font-medium text-[#7a7f87]">
            {/*OneHealth Services LLC*/}
            Loly Tech, Inc &copy; {new Date().getFullYear()}. All Rights Reserved
          </p>
          <p className="mt-2 text-[11px] font-medium leading-relaxed text-[#7a7f87]">
            {FOOTER_DISCLAIMER}
          </p>
        </div>
      </div>
    </footer>
  );
};
